module.exports = __webpack_public_path__ + "static/media/08_720.52cbe0cf.jpeg";